import http from "./http";

export const getValueByKey = () => {
  return http.get(`/api/config/getValueByKey/sys.kf.contact`);
};
export const getCurrencyCode = (data) => {
  const url = `/api/orderInformation/getCurrencyCode`;
  return http.post(url, data);
};
export const updateInfo = (data) => {
  const url = `/api/updateInfo`;
  return http.post(url, data);
};
export const logoutApi = () => {
  return http.get(`/api/logout`);
};
